/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoteTab/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoteTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Payers/Content/NoteTab"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let payersActivetabIdValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab.id',
format: fromFormat.not,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let payersActivetabIdValueData1 = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab.id',
format: fromFormat.not,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="NoteTab.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-ZAbF63': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="NoteTab.Vertical"
  data-view-path={viewPath}
 style={{'--pb-2-ZAbF63': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-1-ZAbF63': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-3-ZAbF63': payersActivetabIdValueData ? dtColorsBrandGreen : dtColorsBrandGreen,'--bs-4-ZAbF63': payersActivetabIdValueData ? "solid" : "solid",'--bbw-5-ZAbF63': payersActivetabIdValueData ? "2px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={payersActivetabIdValueData1 ? dtColorsBrandGreen : dtColorsNeutral900}
 weight="medium"
 text="Notes"
 data="payers.activeTab.id"
 format="/Data/format.js not"
/>
</div>
<div
  data-testid="NoteTab.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-6-ZAbF63': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}